import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  AccessDeniedError,
  TASK_DELETED,
  useProjectTasksService,
} from 'nekst-api';
import { POPUP_CLOSED } from 'ui-builder';
import { useEventsSubscriber } from 'event-bus';
import { useOpenUpdateFormHelper } from '../../projects/view/tasks/CreateUpdate/OpenUpdateFormField';

function useTaskIdParam() {
  const { search, pathname } = useLocation();
  const navigate = useNavigate();

  const getTaskId = () => {
    const param = new URLSearchParams(search).get('taskId');
    return param ? parseInt(param, 10) : null;
  };

  const removeTaskId = () => {
    navigate(pathname);
  };

  return { getTaskId, removeTaskId };
}

export default function TaskOpenerByQueryParam() {
  const taskService = useProjectTasksService();
  const openHelper = useOpenUpdateFormHelper();
  const { getTaskId, removeTaskId } = useTaskIdParam();
  const location = useLocation();

  const taskId = getTaskId();

  useEffect(() => {
    if (taskId) {
      const openTask = async () => {
        try {
          const task = await taskService.getTask(taskId);
          openHelper.openForm(task);
        } catch (e) {
          if (e instanceof AccessDeniedError) {
            removeTaskId();
          } else {
            throw e;
          }
        }
      };
      openTask();
    }
  }, [taskId]);

  useEventsSubscriber(
    'TaskOpenerByQueryParam-popupClosed',
    {
      [POPUP_CLOSED]: () => {
        if (getTaskId()) {
          removeTaskId();
        }
      },
    },
    [location.search],
  );

  useEventsSubscriber(
    'TaskOpenerByQueryParam-taskDeleted',
    {
      [TASK_DELETED]: (eventData) => {
        if (getTaskId() === eventData.id) {
          removeTaskId();
        }
      },
    },
    [location.search],
  );

  return null;
}
